import React, {useEffect, useRef, useState} from 'react';
import Layout from '../../../components/layout/Layout';
import {sendData} from "../../../store/actions";
import {useHistory, useParams} from 'react-router-dom'
import {useDispatch} from "react-redux";
import useSocket from "../../common/useSocket";
import UInput from "ubs-framework/v2/UInput";
import * as Icon from "ubs-icons"
import AppHeader from "../../common/components/app-header";
import Validator from "simple-react-validator";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import Commonrightcircle from "../../../common/component/RightCircle/commonrightcircle";
import {withRouter} from "../../../common/hocs/routing-hoc";

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

function OnBoardingForgotPassword(props) {
    const {orgId} = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const [errorMsg, setErrorMsg] = useState("");
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [email, setEmail] = useState("")

    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: {forceUpdate}
    }));
    const {on, off, refresh} = useSocket(res => {
        setDisabledBtn(false)
        if (!res.error) {
            switch (res.event) {
                case 'onboardingForgotPassword':

                    history.push(props?.projectRoutes?.email || `/${orgId}/email-sent`)
                    break;
                default:
                    return true;
            }
        } else {
            setErrorMsg(res.data.error)
            setTimeout(() => setErrorMsg(res.data.error), 5000)
        }
    })

    const onSubmit = data => {
        if (validator?.current?.allValid()) {
            setDisabledBtn(true)
            sendData(dispatch, 'onboardingForgotPassword', {email, orgId});
        } else {
            validator?.current?.showMessages()
        }

    }
    useEffect(() => {
        on()
        return () => off();
    }, [])

    const onKeyUp = e => {
        if (e.key === "Enter") {
            onSubmit(e)
        }
    }

    return (
        <React.Fragment>
            <Layout module="on-boarding-forgot">
                <div className="u_account-form">
                    <Commonrightcircle/>
                    <AppHeader header="Forgot Password?"
                               title="Enter the email address associated with your account and we will send you the link to reset password."/>
                    <UInput
                        className={`${errorMsg ? 'u_mb-15' : 'u_mb-30'}`}
                        label="Email Address"
                        asterisk
                        hasError={validator?.current?.message("email", email, "required|email")}
                        testId={TEST_ID.FORGOT_PASSWORD.FORGOT_PASSWORD_INPUT_WRAPPER}>
                        <input
                            onKeyUp={onKeyUp}
                            type="text"
                            value={email}
                            name="email"
                            onChange={(e) => {
                                setEmail(e.target.value = e.target.value.replace(/^\s+/g, ''))
                            }}
                            placeholder=" "
                            data-testid={TEST_ID.FORGOT_PASSWORD.FORGOT_PASSWORD_EMAIL_INPUT} />
                    </UInput>
                    {errorMsg.length !== 0 && <p className="u_error-message u_mb-15">{errorMsg}</p>}
                    <div className="u_block u_relative">
                        <button
                            disabled={disabledBtn}
                            type="button"
                            onClick={onSubmit}
                            className={`u_account-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}
                            data-testid={TEST_ID.FORGOT_PASSWORD.FORGOT_PASSWORD_SUBMIT_BUTTON}>Submit
                        </button>
                        {disabledBtn && <div className="u_btn-loader"><Icon.Preloader size={70} /></div>}
                    </div>

                </div>
            </Layout>
        </React.Fragment>
    );
}


export default withRouter(OnBoardingForgotPassword);

